<template>
  <!-- Redesigned top bar (preview). Mirrors NavBar/TheHeader with the
       "Queues Redesign" look: a flush white 64px bar. -->
  <div class="topbar titlebar-drag flex items-center gap-4 w-full px-6">
    <button
      class="topbar-icon-btn"
      @click="setIsCollapsed(!isCollapsed)"
    >
      <v-icon color="#26403D">mdi-menu</v-icon>
    </button>
    <Image :src="logo" imageClass="w-8" />
    <div class="text-lg font-bold" style="color: #14857a; letter-spacing: -0.01em">
      {{ title ? $t(`layouts.${title}`) : "" }}
    </div>

    <div class="ms-auto flex items-center gap-3">
      <div class="flex flex-col items-end">
        <span class="text-sm font-bold" style="color: #26403d">{{ fullname }}</span>
        <button class="flex items-center gap-1.5" @click="toggle">
          <span
            class="rounded-full"
            :style="{
              width: '7px',
              height: '7px',
              background: statusColor,
            }"
          ></span>
          <span class="text-xs" :style="{ color: statusColor }">
            {{ statusLabel }}
          </span>
        </button>
        <Popover ref="statusPopover">
          <AgentStatusSelect
            :style="$i18n.locale == 'ar' ? 'direction: rtl;' : 'direction: ltr;'"
          />
        </Popover>
      </div>
      <RouterLink :to="getbaseURL + '/Profile'">
        <Avatar
          size="large"
          shape="circle"
          class="bg-light-grey"
          :image="avatar ? avatar : require('@/assets/user.png')"
        ></Avatar>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Avatar, Popover, Image } from "primevue";
import AgentStatusSelect from "@/pages/agent/dashboard/components/AgentStatusSelect.vue";

export default {
  name: "AppTopBarNew",
  components: { Avatar, Popover, Image, AgentStatusSelect },
  computed: {
    ...mapGetters([
      "getbaseURL",
      "status",
      "isConnected",
      "fullname",
      "avatar",
      "logos",
      "isCollapsed",
    ]),
    title() {
      return this.$route.name;
    },
    logo() {
      const logosList = JSON.parse(this.logos);
      if (!logosList || !logosList?.menu_logo || logosList?.menu_logo == "") {
        return require("@/assets/logo.png");
      }
      return logosList.menu_logo;
    },
    statusColor() {
      if (this.status == 3) return "#ef4444";
      if (this.status == 2) return "#eab308";
      return this.isConnected ? "#3FA88A" : "#9AAEAB";
    },
    statusLabel() {
      if (this.status == 1) {
        return this.isConnected
          ? this.$t("home.agent_status.online_status")
          : this.$t("home.agent_status.offline_status");
      }
      return this.status == 2
        ? this.$t("home.agent_status.rest_status")
        : this.$t("home.agent_status.busy_status");
    },
  },
  methods: {
    ...mapMutations(["setIsCollapsed"]),
    toggle(event) {
      this.$refs.statusPopover.toggle(event);
    },
  },
};
</script>

<style scoped>
.topbar {
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #e6eceb;
}
.topbar-icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;
}
.topbar-icon-btn:hover {
  background: #f1f4f3;
}
</style>
